
import { IconComponents } from "components/Icon";
import "./Menu.css";
import { ListItem, ListItemButton, ListItemIcon, ListItemText, Tooltip } from "@mui/material";
import React, { useCallback, useContext } from "react";
import { RouterDOM } from "utilities/utilities";
import { IMenuItem } from "./MenuProps";
import { ProviderLayout } from "view/ExampleLayout/Admin";
import { Link } from "react-router-dom";

const MenuItems = (props: IMenuItem) => {

    const Router = RouterDOM();

    const {
        IsMenuOpen,
        IsOverMouse,
        handleClickMenuOpen
    } = useContext(ProviderLayout);

    const MenuSpace = () => {
        let nLevel = !IsMenuOpen && !IsOverMouse ? 1 : props.nLevel;
        return nLevel * 16 + "px";
    };

    const MenuActive = useCallback(() => {
        let sRouteCurrent = Router.GetCurrentRoute();
        let sRouteMenu = (props.sRoute ?? "").toLowerCase();
        let arrRoute =  props.arrRoute ?? [];
        return sRouteCurrent === sRouteMenu || arrRoute.includes(sRouteCurrent) ? "active" : ""
    }, [window.location.href]);

    return (
        <React.Fragment>
            <Tooltip title={props.sMenuName} placement="right">
                <Link
                    to={props.sRoute}
                    preventScrollReset={true}
                    style={{ textDecoration: 'none' }}
                >
                    <ListItem disablePadding>
                        <ListItemButton
                            key={props.nMenuID}
                            className={`nav-menu-itemH nav-menu-itemH-lv` + props.nLevel + " " + MenuActive()}
                            sx={{ pl: MenuSpace(), minWidth: '40px' }}
                            onClick={() => { 
                                handleClickMenuOpen(props.nMenuID); 
                                Router.GoToPage(props.sRoute); 
                                window.scrollTo(0, 0);
                                // window.location.reload();
                            }}
                        >
                            <ListItemIcon sx={{ ml: '2px' }}>
                                {IconComponents(props.sIcon)}
                            </ListItemIcon>
                            <ListItemText primary={props.sMenuName} primaryTypographyProps={{ style: { whiteSpace: "nowrap", overflow: 'hidden', textOverflow: 'ellipsis' } }} />
                        </ListItemButton>
                    </ListItem>
                </Link>
            </Tooltip>
        </React.Fragment>
    )
}
export default MenuItems;
